import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PastHealthHistory, PastHealthHistoryObj } from '../../../core/models/patient/PastHealthHostoryQuestions';
import { Patient } from '../../../core/models/patient/patient';
import { PatientHealthHistory } from '../../../core/models/patient/PatientHealthHistory';
import { patientHealthSubType, patientHealthType } from '../../../core/models/patient/patientHealthType';
import { CommonService } from '../../../core/services/v2/common.service';
import { PatientService } from '../../../core/services/v2/patient.service';
import { WindowLoaderService } from '../../../shared/components/window-loader/window-loader.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-patient-family-history',
  templateUrl: './patient-family-history.component.html',
  styleUrls: ['./patient-family-history.component.scss']
})
export class PatientFamilyHistoryComponent implements OnChanges {
  @Input() editEnable: boolean;
  @Input() patientProfile: Patient;
  @Input() patientHealthHistories: PatientHealthHistory[];
  @Input() patientHealthTypes: patientHealthType[];
  @Input() healthHistoryQuestions: PastHealthHistory[];
  @ViewChild('#patientFamilyHistoryForm', null) patientFamilyHistoryForm: NgForm;
  pastHistoryStaticQuestions: PastHealthHistory[];

  patientHealthSubTypes: patientHealthSubType[];
  pastHealthHistoryObj: PastHealthHistoryObj[];


  constructor(private patientService: PatientService,
    private router: ActivatedRoute,
    private loaderService: WindowLoaderService,
    private commonService: CommonService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.healthHistoryQuestions && this.healthHistoryQuestions.length > 0) {
      this.pastHistoryStaticQuestions = this.healthHistoryQuestions.filter(x => x.typeId == 3);
      if (this.patientHealthTypes && this.patientHealthHistories) {
        this.patientHealthSubTypes = this.patientHealthTypes.find(x => x.id == 3).healthSubTypes;
        this.mapPastHealthHistoryObj();
      }
    }
  }

  mapPastHealthHistoryObj() {
    this.pastHealthHistoryObj = [];
    for (var value of this.patientHealthSubTypes) {
      let data = null;
      let patientHealthHistoryId: number = 0;
      if (this.patientHealthHistories && this.patientHealthHistories.length > 0) {
        const patientHeathHisory = this.patientHealthHistories.find(x => x.typeId == value.typeId && x.subTypeId == value.id);
        if (patientHeathHisory) {
          patientHealthHistoryId = patientHeathHisory.id;
          const dataString = patientHeathHisory.healthData;
          if (dataString && dataString != '') {
            data = JSON.parse(dataString);
          }
        }
      }
      if (!data) {
        data = _.cloneDeep(this.pastHistoryStaticQuestions.find(x => x.typeId == value.typeId && x.subTypeId == value.id).data);
      }
      let dataAvailable = "No";
      if (patientHealthHistoryId > 0) {
        dataAvailable = "Yes";
      }
      this.pastHealthHistoryObj.push({ patientHealthHistoryId: patientHealthHistoryId, dataAvailable: dataAvailable, typeId: value.typeId, subTypeId: value.id, subTypeName: value.name, healthData: data, showData: false, dataCount: 0 });
    }
  }

  saveDiseaseData(healthHistory: PastHealthHistoryObj, subTypeIndex: number) {
    console.log('healthDiseaseData ->', healthHistory);
    const healthData = JSON.stringify(healthHistory.healthData);
    const PatientHealthHistoryData: PatientHealthHistory[] = [{
      id: healthHistory.patientHealthHistoryId,
      patientId: this.patientProfile.id,
      typeId: healthHistory.typeId,
      subTypeId: healthHistory.subTypeId,
      healthData: healthData,
      subTypeName: null,
      typeName: null,
      active: true
    }];
    this.loaderService.blockWithLoader(this.patientService.savePatientHealthHistoryData(PatientHealthHistoryData)).subscribe(
      (details) => {
        if (details.isSuccess) {
          let data = this.pastHealthHistoryObj[subTypeIndex];
          data.dataAvailable = "Yes";
          this.pastHealthHistoryObj[subTypeIndex] = data;
          //todo refresh patientHealthHistoryId
        }
      },
      (error) => { console.error(error); }
    );
  }

  toggleCard(index: number) {
    let data = this.pastHealthHistoryObj;
    this.pastHealthHistoryObj[index].showData = !data[index].showData;
    //this.pastHealthHistoryObj = data;
  }

  addNew(healthHistory: PastHealthHistoryObj, subTypeId: number, subTypeIndex:number) {
    const newQuestionsSet = _.cloneDeep(this.pastHistoryStaticQuestions.find(x => x.subTypeId == subTypeId).data[0].qArr[0]);
    newQuestionsSet.id = Math.floor(Math.random() * (999 - 100 + 1) + 100);
    let data = _.cloneDeep(healthHistory);
    data.healthData[0].qArr.push(newQuestionsSet);
    this.pastHealthHistoryObj[subTypeIndex] = data;
  }

  removeItem(diseaseArr: any, index: number) {
    let healthData = diseaseArr;
    healthData.qArr.splice(index, 1);
    diseaseArr = healthData;
  }

}
